import type { LoadableType } from '@confluence/loadable';
import { LoadableBackground } from '@confluence/loadable';

export const SatisfactionSurveysLoader: LoadableType<{
	contentId: string;
	isEditorExpEnabled: boolean;
}> = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SatisfactionSurveys" */ './SatisfactionSurveys.tsx'
			)
		).SatisfactionSurveys,
});
